<template>
  <div>
    <usertop :nickname="nickname" :avatar="avatar" :mobile="mobile" :agentStatus="agentStatus" />
    <div class="box">
      <div class="box-t">
        <div class="box-t-1">我发布的</div>
        <div class="box-t-2"></div>
      </div>
      <div class="box-c">
        <van-row>
          <van-col span="6">
            <div class="user-tag" @click="$router.push('/user/ershoufang')">
              <p>
                <img src="../../../assets/images/usericon1.png" />
              </p>
              <h1>二手房管理</h1>
            </div>
          </van-col>
          <van-col span="6">
            <div class="user-tag" @click="$router.push('/user/zufang')">
              <p>
                <img src="../../../assets/images/usericon2.png" />
              </p>
              <h1>租房管理</h1>
            </div>
          </van-col>
          <van-col span="6">
            <div class="user-tag" @click="$router.push('/user/shop')">
              <p>
                <img src="../../../assets/images/usericon3.png" />
              </p>
              <h1>商铺管理</h1>
            </div>
          </van-col>
          <van-col span="6">
            <div class="user-tag" @click="$router.push('/user/general/tuoguan')">
              <p>
                <img src="../../../assets/images/index-5.png" />
              </p>
              <h1>托管房源</h1>
            </div>
          </van-col>
		  
		<!--  <van-col span="6" v-if="agentStatus==0">
		    <div class="user-tag" @click="$router.push('/user/apply')">
		      <p>
		        <img src="../../../assets/images/index-8.png" />
		      </p>
		      <h1>申请经纪人</h1>
		    </div>
		  </van-col> -->
		  <van-col span="6" v-if="agentStatus==1">
		    <div class="user-tag" @click="$router.push('/user/agent/ershoufang')">
		      <p>
		        <img src="../../../assets/images/index-8.png" />
		      </p>
		      <h1>经纪人管理</h1>
		    </div>
		  </van-col>

        </van-row>
      </div>
    </div>
    <div class="box">
      <div class="box-t">
        <div class="box-t-1">常用工具</div>
        <div class="box-t-2" @click="$router.push('/house')"></div>
      </div>
      <div class="box-c">
        <van-row>
         <!-- <van-col span="6">
            <div class="user-tag"  @click="$router.push('/user/general/nopay')">
              <p>
                <van-icon name="bill-o" size="24" />
              </p>
              <h1>未支付</h1>
            </div>
          </van-col> -->
          <van-col span="6">
            <div class="user-tag" @click="$router.push('/favor')">
              <p>
                <van-icon name="like-o" size="24" />
              </p>
              <h1>我的关注</h1>
            </div>
          </van-col>
          <van-col span="6">
            <div class="user-tag" @click="$router.push('/order')">
              <p>
                <van-icon name="orders-o" size="24" />
              </p>
              <h1>我的订单</h1>
            </div>
          </van-col>
          <van-col span="6">
            <div class="user-tag" @click="showService">
              <p>
                <van-icon name="manager-o" size="24" />
              </p>
              <h1>联系客服</h1>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="user-logout" @click="logout">退出登录</div>

    <footbar />
  </div>
</template>

<script>
var root = process.env.VUE_APP_API_URL;
import Footbar from "../../commpents/footbar";
import Usertop from "../../commpents/usertop";
import { Toast, Cell, CellGroup, Button, Icon, Row, Col, Dialog } from "vant";

export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    Footbar,
    Usertop
  },

  data() {
    return {
      getInitUrl: root + "user/index",
      agent: 0,
      agentStatus: 0,
      agentVip: "",
      txt: "",
      username: "",
      nickname: "",
      mobile: "",
      avatar: ""
    };
  },
  mounted() {
    this.init();
  },

  methods: {
    init() {
      var self = this;
      $.ajax({
        url: self.getInitUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: {},
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          if (reponseData.data.islogin == 0) {
            self.$router.push("/login");
          }
          self.username = reponseData.data.username;
          self.nickname = reponseData.data.nickname;
          self.mobile = reponseData.data.mobile;
          self.avatar = reponseData.data.avatar;
          self.agent = reponseData.data.agent;
          self.agentStatus = reponseData.data.agentStatus;
          self.agentVip = reponseData.data.agentVip;
          self.avastar = reponseData.data.avastar;
  
          console.log(reponseData.data);
          self.$emit("change", reponseData.data);
        },
        error: function() {
          self.$toast("system error");
        }
      });
    },
    logout() {
      var storage = window.localStorage;
      storage.removeItem("accessToken");
      this.$router.push("/login");
    },
    getData(data) {
      this.agent = data.agent;
      this.agentStatus = data.agentStatus;
      this.agentVip = data.agentVip;
      if (this.agent) {
        if (this.agentStatus == 0) {
          this.txt = "审核中";
        }
        if (this.agentStatus == 1) {
          this.txt = this.agentVip;
        }
      }
    },
    jingjiren() {
      if (this.agent) {
        if (this.agentStatus == 0) {
          this.$toast("正在审核中");
        }
        if (this.agentStatus == 1) {
          this.$toast("已经是经纪人");
        }
      } else {
        this.$router.push("/user/jingjiren");
      }
    },
    showService() {
      this.$dialog
        .alert({
          title: "客服服务",
          message: "联系电话：73372998"
        })
        .then(() => {
          // on close
		  location.href="tel:02373372998"
        });
    }
  }
};
</script>

<style scoped>
.user-tag {
  text-align: center;
  padding: 10px 0;
}
.user-tag img {
  width: 32px;
  height: 32px;
}
.user-tag h1 {
  margin-top: 6px;
  font-size: 14px;
  font-weight: normal;
  color: #555;
  height: 20px;
  line-height: 20px;
}
.user-logout {
  text-align: center;
  padding: 15px;
  margin: 15px;
  background-color: #f8f8f8;
  border-radius: 4px;
}
</style>



